import React from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

import RightArrow from '../../assets/images/right-arrow.png';

export default function ServicesSection() {
  return (
    <>
      <div className='our-services-section'>
        <h2 className='section-title'>What We Do at Starlife Group</h2>
        <p>
          We offer a vertically integrated platform built to create value at
          every stage of a real estate venture — from concept to completion,
          capital to care. Our services fall into three core pillars.
        </p>
        <div className='service-list'>
          <Link to={ROUTE_NAMES.DEVELOPMENTDESIGN} className='service-block'>
            <h3>Development Services</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.CONSTRUCTIONSERVICE}
            className='service-block green-block'
          >
            <h3>Construction Services</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.CAPITALINVESTMENT} className='service-block'>
            <h3>Capital Services</h3>
            <button className='right-arrow-btn' style={{ cursor: 'pointer' }}>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.BROKERAGESERVICES}
            className='service-block green-block'
          >
            <h3>Brokerage Services</h3>
            <button className='right-arrow-btn' style={{ cursor: 'pointer' }}>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.MORTGAGESERVICES} className='service-block'>
            <h3>Mortgage Services</h3>
            <button className='right-arrow-btn' style={{ cursor: 'pointer' }}>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link
            to={ROUTE_NAMES.LENDINGSERVICES}
            className='service-block green-block'
          >
            <h3>Lending Services</h3>
            <button className='right-arrow-btn' style={{ cursor: 'pointer' }}>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
    </>
  );
}
